define('OutSystems/ReactWidgets/AbstractButtonGroup',["require", "exports", "tslib", "OutSystems/ClientRuntime/DataTypes", "OutSystems/ReactView/Widget", "react"], function (require, exports, tslib_1, DataTypes_1, Widget_1, React) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.AbstractButtonGroup = void 0;
    var AbstractButtonGroup = (function (_super) {
        tslib_1.__extends(AbstractButtonGroup, _super);
        function AbstractButtonGroup() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.selectedValue = null;
            _this.selectedElementId = null;
            return _this;
        }
        AbstractButtonGroup.prototype.syncSelectedValueWithProps = function () {
            var _this = this;
            this.selectedValue = null;
            var found = false;
            React.Children.forEach(this.props.children, function (child) {
                found = found || (child && child.props && (0, DataTypes_1.equals)(_this.props.variable.value, child.props.value));
            });
            this.selectedValue = found ? this.props.variable.value : null;
        };
        AbstractButtonGroup.prototype.componentDidMount = function () {
            this.syncSelectedValueWithProps();
        };
        AbstractButtonGroup.prototype.componentDidUpdate = function () {
            this.syncSelectedValueWithProps();
        };
        AbstractButtonGroup.prototype.updateValue = function (value) {
            var _this = this;
            if ((0, DataTypes_1.equals)(this.props.variable.value, value)) {
                return;
            }
            this.selectedValue = value;
            this.props.variable.value = value;
            if (this.props.onChange) {
                this.executeAfterPaint(function () {
                    _this.props.onChange();
                });
            }
        };
        Object.defineProperty(AbstractButtonGroup.prototype, "variable", {
            get: function () {
                return this.props.variable;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(AbstractButtonGroup.prototype, "htmlElement", {
            get: function () {
                return this.getHTMLNode();
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(AbstractButtonGroup.prototype, "isMandatory", {
            get: function () {
                return this.props.mandatory;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(AbstractButtonGroup.prototype, "inputedValue", {
            get: function () {
                return this.selectedValue;
            },
            enumerable: false,
            configurable: true
        });
        AbstractButtonGroup.prototype.render = function () {
            var _a;
            var _this = this;
            var dataAttribute = this.getDataAttribute();
            var children = React.Children.map(this.props.children, function (child, index) {
                if (child && child.props) {
                    child = React.cloneElement(child, tslib_1.__assign({ isSelected: (0, DataTypes_1.equals)(_this.props.variable.value, child.props.value), enabled: child.props.enabled && _this.props.enabled, updateValueInParent: function (value) {
                            _this.updateValue(value);
                        }, key: index }, _this.getAdditionalPropsToChild()));
                    if ((0, DataTypes_1.equals)(_this.props.variable.value, child.props.value)) {
                        var idProperties = child.props._idProps;
                        _this.selectedElementId = idProperties.service.getId(idProperties.name);
                    }
                }
                return child;
            });
            var inputGroupContainerAttributes = (_a = {},
                _a[dataAttribute] = "",
                _a.className = this.props.style,
                _a.role = "radiogroup",
                _a["aria-activedescendant"] = this.selectedElementId,
                _a);
            this.fillWithBuiltinProperties(inputGroupContainerAttributes);
            return (React.createElement("div", tslib_1.__assign({}, inputGroupContainerAttributes),
                React.createElement("div", null, children),
                this.createValidationElement()));
        };
        return AbstractButtonGroup;
    }(Widget_1.InputWithVariableWidget));
    exports.AbstractButtonGroup = AbstractButtonGroup;
});
//# sourceMappingURL=AbstractButtonGroup.js.map;
